import React from 'react';
import ResCol from './forms/ResCol';
import { SearchValue, FormItemWrap } from 'react-structure-admin';

const defaultColumns = [
  {
    title: 'Código',
    dataIndex: 'code',
    isKey: true,
    width: '25%'
  },
  {
    title: 'Descrição',
    dataIndex: 'description',
    width: '75%'
  }
];

const SearchInput = ({
  showComponent = true,
  span = 12,
  label,
  name,
  placeholder,
  drawerSize = '50%',
  title,
  resource,
  disabled = false,
  maxLength = 20,
  columns = defaultColumns,
  rules
}) => {
  return (
    <>
      {showComponent ? (
        <ResCol span={span}>
          <FormItemWrap label={label} name={name} rules={rules}>
            <SearchValue
              placeholder={placeholder}
              drawerSize={drawerSize}
              title={title}
              resource={resource}
              disabled={disabled}
              maxLength={maxLength}
              columns={columns}
            />
          </FormItemWrap>
        </ResCol>
      ) : null}
    </>
  );
};

export default SearchInput;
